// src/utils/analytics.js

/**
 * Pieni apufunktio: tarkistetaan, että gtag on olemassa
 * ennen kuin yritetään lähettää mitään GA4:ään.
 */
function hasGtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

/**
 * SPA-page_view – kutsu tätä aina kun reitti vaihtuu.
 *
 * @param {string} path  Virtuaalinen polku, esim. "/bilebandi-juhliin"
 * @param {string} title Sivun otsikko, esim. "Bilebändi juhliin – koko Suomi | Buukkeri"
 */
export function trackPageView(path, title) {
  if (!hasGtag()) return;

  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: path,
    page_title: title,
  });
}

/**
 * Yleis-eventti esim. CTA-napeille, hakufilttereille ym.
 *
 * Esimerkki:
 *   trackEvent("cta_click", {
 *     label: "bilebandi_hero_cta",
 *     location: "bilebandi_juhliin_landing"
 *   });
 *
 * @param {string} name   Eventin nimi (esim. "cta_click", "search_open")
 * @param {object} params Lisäparametrit (vapaat avain–arvo -parit)
 */
export function trackEvent(name, params = {}) {
  if (!hasGtag()) return;

  window.gtag("event", name, params);
}

/**
 * Erikois-event ländäreiden CTA-klikeille.
 *
 * Käyttö:
 *   trackLandingCta({
 *     actType: "bilebandi",      // "bilebandi" | "dj" | "trubaduuri"
 *     region: "uusimaa",         // esim. "koko_suomi", "uusimaa", "pirkanmaa"
 *     placement: "hero"          // esim. "hero", "footer", "content"
 *   });
 *
 * GA4-event: "landing_cta_click"
 *  - act_type  = bilebandi / dj / trubaduuri
 *  - region    = maakunta (tai "koko_suomi")
 *  - placement = napin sijainti sivulla
 */
export function trackLandingCta({ actType, region, placement }) {
  trackEvent("landing_cta_click", {
    act_type: actType,
    region,
    placement,
  });
}
